/**
 * タイミング・ディレイ・タイムアウト関連の定数
 * アプリケーション全体で使用されるタイミング設定の一元管理
 */

export const TIMING = {
  // API timeouts
  API_REQUEST_TIMEOUT: 30000, // 30秒
  PDF_FETCH_TIMEOUT: 10000, // 10秒
  PDF_RENDER_TIMEOUT: 5000, // 5秒

  // Delays
  BOOTSTRAP_DELAY: 500, // ブートストラップ遅延
  FOCUS_MODE_STATE_SAVE_DELAY: 100, // フォーカスモード状態保存遅延
  PDF_REFRESH_AFTER_FOCUS_MODE_DELAY: 400, // フォーカスモード後のPDF更新遅延
  DEFAULT_DEBOUNCE_DELAY: 300, // デフォルトデバウンス遅延
  TYPING_WATCHER_DEBOUNCE: 500, // タイピング監視デバウンス
  MOCK_RESPONSE_DEFAULT_DELAY: 500, // モックレスポンスデフォルト遅延

  // Animations
  IMAGE_TRANSITION_DURATION: 1000, // 画像トランジション時間
  IMAGE_MANUAL_SWITCH_DURATION: 800, // 手動画像切り替え時間
  IMAGE_AUTO_SWITCH_INTERVAL: 15000, // 自動画像切り替え間隔
  FOCUS_MODE_TEXT_DELAY: 800, // フォーカスモードテキスト遅延

  // Announcements
  SUCCESS_ANNOUNCEMENT_DURATION: 3000, // 成功アナウンス表示時間
  ERROR_ANNOUNCEMENT_DURATION: 5000, // エラーアナウンス表示時間
  IMAGE_SUCCESS_INDICATOR_DURATION: 3000, // 画像成功インジケーター表示時間

  // Data sync
  USER_DATA_SAVE_DEBOUNCE: 1000, // ユーザーデータ保存デバウンス
  PDF_GENERATION_RETRY_DELAY: 1000, // PDF生成リトライ遅延

  // PDF generation
  PDF_GENERATION_TIMEOUT: 5000, // PDF生成タイムアウト
  PDF_CHECK_INTERVAL: 100, // PDFチェック間隔
  PDF_CHECK_QUIET_PERIOD: 150, // PDFチェック静止期間

  // Query cache
  QUERY_CACHE_DURATION_SECONDS: 600, // クエリキャッシュ期間（秒）
  PDF_REFRESH_INTERVAL: 500, // PDF更新間隔
} as const;
